import { CalendarType, CalendarTypeDefinitions } from "@/constants/Calendar";
import { Switch, Text } from "@/ui/core";
import { BaseCard, HStack, VStack } from "@/ui/layout";
import { isIOS } from "@/utils/platform.util";
import { joinTestIDs } from "@/utils/string.util";

interface CalendarToggleCardProps extends ViewWithTestID {
  isDeviceCalendarEnabled: boolean;
  isGoogleCalendarEnabled: boolean;
  onDeviceCalendarChange: (isEnabled: boolean) => void;
  onGoogleCalendarChange: (isEnabled: boolean) => void;
  shouldShowDeviceCalendar?: boolean;
  title?: string;
}

interface CalendarRowProps extends ViewWithTestID {
  calendarType: CalendarType;
  isEnabled: boolean;
  onToggle: (isEnabled: boolean) => void;
}

const CalendarRow = ({
  calendarType,
  isEnabled,
  onToggle,
  testID,
}: CalendarRowProps) => {
  const { Icon, name } = CalendarTypeDefinitions[calendarType];

  return (
    <HStack alignItems="center" justifyContent="space-between">
      <HStack alignItems="center" gap={8}>
        <Icon />
        <Text testID={joinTestIDs(testID, "text")}>{name}</Text>
      </HStack>
      <Switch
        isChecked={isEnabled}
        onCheckedChange={onToggle}
        testID={testID}
      />
    </HStack>
  );
};

const CalendarToggleCard = ({
  isDeviceCalendarEnabled,
  isGoogleCalendarEnabled,
  onDeviceCalendarChange,
  onGoogleCalendarChange,
  shouldShowDeviceCalendar = isIOS(),
  testID,
  title = "Sync calendars",
}: CalendarToggleCardProps) => (
  <BaseCard testID={testID}>
    <VStack gap={16}>
      <Text testID={joinTestIDs(testID, "header")} variant="bodyMedium">
        {title}
      </Text>
      <VStack gap={12}>
        <CalendarRow
          calendarType={CalendarType.Google}
          isEnabled={isGoogleCalendarEnabled}
          onToggle={onGoogleCalendarChange}
          testID={joinTestIDs(testID, "google")}
        />

        {shouldShowDeviceCalendar && (
          <CalendarRow
            calendarType={CalendarType.Apple}
            isEnabled={isDeviceCalendarEnabled}
            onToggle={onDeviceCalendarChange}
            testID={joinTestIDs(testID, "device")}
          />
        )}
      </VStack>
    </VStack>
  </BaseCard>
);
export default CalendarToggleCard;
export type { CalendarToggleCardProps };
